import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import Icon from '../../../Icon';
import TextInput from '../../../TextInput';
import SelectCustom from '../../../SelectCustom';
import ErrorBlock from '../../../common/ErrorBlock';
import AmountInput from '../../../common/AmountInput';
import { COLORS } from '../../../../constants/styles';
import TimePickerInput from '../../../common/TimePickerInput';
import DatePickerCustom from '../../../common/DatePickerCustom';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { yesterday } from '../../../../utils/converters/dateConverters';
import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../utils/fields/getFieldProps';
import styles from '../../../DependentForm/styles.styl';

const {
  DATE,
  COPAY,
  SERVICE,
  LOCATION,
  PROVIDER,
  START_TIME,
  REASON_TYPE,
  REASON_NOTE,
  REASON_TYPE_ID,
} = PROFILE_FIELDS_TYPES;

function VisitInfoForm({
  errors,
  formatMessage,
  onChange,
  date,
  copay,
  startTime,
  locationsList,
  servicesList,
  reasonList,
  providersList,
  locationId,
  serviceId,
  reasonTypeId,
  reasonNote,
  providerId,
  showTimeError,
  loadingReasonTypes,
  handleCopayChange,
}) {
  const makeField = getFieldProps(formatMessage, onChange);

  return (
    <Fragment>
      <div styleName="row row--justify">
        <div className="relative">
          <DatePickerCustom
            value={date}
            label={formatMessage({ id: 'common.date' })}
            name={DATE}
            minDate={yesterday}
            onChange={value => onChange({ [DATE]: value })}
          />
          <Icon
            styleName="input-icon"
            name="calendar"
            style={{ fill: COLORS.bluePrimary }}
          />
        </div>
        <TimePickerInput
          withCurrentTime
          value={startTime}
          name={START_TIME}
          onChange={value => onChange({ [START_TIME]: value })}
          label={formatMessage({ id: 'reports.time' })}
          placeholder={formatMessage({ id: 'reports.time' })}
        />
      </div>
      <If condition={showTimeError}>
        <ErrorBlock
          errors={formatMessage({ id: 'virtualVisit.details.futureTime' })}
          className="mt3"
        />
      </If>
      <SelectCustom
        {...makeField(LOCATION, FIELD_FILLING_TYPES.REQUIRED)}
        options={locationsList}
        value={locationId}
        needUpdateDefaultValue
      />
      <SelectCustom
        {...makeField(SERVICE, FIELD_FILLING_TYPES.REQUIRED)}
        options={servicesList}
        value={serviceId}
        needUpdateDefaultValue
        disabled={!locationId}
      />
      <SelectCustom
        {...makeField(REASON_TYPE, FIELD_FILLING_TYPES.REQUIRED)}
        options={reasonList}
        value={reasonTypeId}
        needUpdateDefaultValue
        name={REASON_TYPE_ID}
        onChange={({ value }) => onChange({ [REASON_TYPE_ID]: value })}
        isLoading={loadingReasonTypes}
        disabled={!serviceId || loadingReasonTypes}
      />
      <TextInput
        {...makeField(REASON_NOTE, FIELD_FILLING_TYPES.OPTIONAL)}
        value={reasonNote}
      />
      <SelectCustom
        {...makeField(PROVIDER, FIELD_FILLING_TYPES.OPTIONAL)}
        options={providersList}
        value={providerId}
        canSearch
        label={formatMessage({
          id: 'virtualVisit.details.appointmentProvider',
        })}
      />
      <AmountInput
        {...makeField(COPAY, FIELD_FILLING_TYPES.OPTIONAL)}
        rounded
        name={COPAY}
        value={copay}
        onChange={handleCopayChange}
      />
      <If condition={Boolean(errors)}>
        <ErrorBlock errors={get(errors, 'description')} className="mt3" />
      </If>
    </Fragment>
  );
}

VisitInfoForm.propTypes = {
  date: PropTypes.instanceOf(Date),
  errors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
  formatMessage: PropTypes.func,
  onChange: PropTypes.func,
  locationId: PropTypes.number,
  serviceId: PropTypes.number,
  reasonTypeId: PropTypes.number,
  providerId: PropTypes.number,
  locationsList: PropTypes.array,
  servicesList: PropTypes.array,
  reasonList: PropTypes.array,
  providersList: PropTypes.array,
  reasonNote: PropTypes.string,
  copay: PropTypes.string,
  startTime: PropTypes.string,
  loadingReasonTypes: PropTypes.bool,
  showTimeError: PropTypes.bool,
  handleCopayChange: PropTypes.func,
};

export default CSSModules(VisitInfoForm, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/VirtualVisit/VisitDetails/VisitInfoForm/index.jsx